module.exports = __webpack_public_path__ + "static/media/maxinvest logo.4c411e07.png";